import { defineMessages } from 'react-intl';

export const handlingUnitsStepMessages = defineMessages({
  handlingUnitTitle: {
    defaultMessage: 'Handling Unit {number}',
    id: 'E7qa3x',
    description: 'Title for a handling unit card in the booking wizard',
  },
  removeHandlingUnit: {
    defaultMessage: 'Remove',
    id: 'eZ6Jum',
    description: 'Button to remove a handling unit',
  },
  quantityLabel: {
    defaultMessage: 'Quantity',
    id: 'Xs1BCX',
    description: 'Label for the handling unit quantity input',
  },
  unitTypeLabel: {
    defaultMessage: 'Unit Type',
    id: 'bYlDFT',
    description: 'Label for the handling unit packaging type dropdown',
  },
  stackableLabel: {
    defaultMessage: 'Stackable',
    id: 'OERW8f',
    description: 'Label for the handling unit stackable dropdown',
  },
  stackableYes: {
    defaultMessage: 'Yes',
    id: 'OZM1Yp',
    description: 'Yes option for the stackable dropdown',
  },
  stackableNo: {
    defaultMessage: 'No',
    id: 'KG0ilu',
    description: 'No option for the stackable dropdown',
  },
  addHandlingUnit: {
    defaultMessage: '+ Add Handling Unit',
    id: '1C6Kso',
    description: 'Button to add another handling unit',
  },
  commodityTitle: {
    defaultMessage: 'Commodity {number}',
    id: '52VqGa',
    description: 'Title for a commodity card within a handling unit',
  },
  productNameLabel: {
    defaultMessage: 'Product Name',
    id: 'eX2cSN',
    description: 'Label for the commodity product name search field',
  },
  productNamePlaceholder: {
    defaultMessage: 'Search',
    id: 'siMzmi',
    description: 'Placeholder for the commodity product name search field',
  },
  totalWeightLabel: {
    defaultMessage: 'Total weight',
    id: 'Q2g17V',
    description: 'Label for the commodity total weight input',
  },
  classLabel: {
    defaultMessage: 'Class',
    id: 'kHPbO1',
    description: 'Label for the commodity freight class dropdown',
  },
  classPlaceholder: {
    defaultMessage: 'Select class',
    id: 'G0aUxn',
    description: 'Placeholder for the commodity freight class dropdown',
  },
  calculateDensity: {
    defaultMessage: 'Calculate Density',
    id: 'vOec+s',
    description: 'Button to compute the commodity density from dimensions and weight',
  },
  densityResult: {
    defaultMessage: 'Density: {density} lb/ft³',
    id: 'iqDzFK',
    description: 'Displays the computed commodity density',
  },
  densityNeedsDimensions: {
    defaultMessage: 'Enter dimensions and weight to calculate density',
    id: 'KEYu2V',
    description: 'Hint shown when density cannot be computed because dimensions or weight are missing',
  },
  showCommodityDetails: {
    defaultMessage: 'Show commodity details',
    id: 'muTpg+',
    description: 'Link to reveal the optional commodity detail fields',
  },
  hideCommodityDetails: {
    defaultMessage: 'Hide commodity details',
    id: '/wijIw',
    description: 'Link to hide the optional commodity detail fields',
  },
  addCommodity: {
    defaultMessage: '+ Add Commodity',
    id: 'W1ReiF',
    description: 'Button to add another commodity to a handling unit',
  },
  removeCommodity: {
    defaultMessage: 'Remove',
    id: '25UtUh',
    description: 'Button to remove a commodity from a handling unit',
  },
  nmfcCodeLabel: {
    defaultMessage: 'NMFC Code (Optional)',
    id: 'ejTJnD',
    description: 'Label for the optional NMFC code field',
  },
  nmfcCodePlaceholder: {
    defaultMessage: 'Enter NMFC Code',
    id: 'I5+nwB',
    description: 'Placeholder for the NMFC code field',
  },
  pieceLabel: {
    defaultMessage: 'Piece (Optional)',
    id: 'dQe1we',
    description: 'Label for the optional piece type dropdown',
  },
  piecePlaceholder: {
    defaultMessage: 'Select piece type',
    id: '9HEjXy',
    description: 'Placeholder for the piece type dropdown',
  },
  numberOfPiecesLabel: {
    defaultMessage: 'Number of Pieces (Optional)',
    id: 'GQak+Q',
    description: 'Label for the optional number of pieces input',
  },
  commodityDescriptionLabel: {
    defaultMessage: 'Commodity Description (Optional)',
    id: 'mMJ6Hq',
    description: 'Label for the optional commodity description field',
  },
  commodityDescriptionPlaceholder: {
    defaultMessage: 'Enter description',
    id: 'xEnya9',
    description: 'Placeholder for the commodity description field',
  },
  handlingSectionLabel: {
    defaultMessage: 'Handling Units',
    id: '7AurAj',
    description: 'Section label shown in the completed handling-units step summary',
  },
  summary: {
    defaultMessage: '{count, plural, one {# handling unit} other {# handling units}}, {weight} {unit} total',
    id: 'y1SyzZ',
    description: 'Compact summary of handling units count and total weight',
  },
});
